import ChevronDownFilterIcon from '@assets/icons/chevron-down-filter.svg';
import { BORDER_COLORS } from '@constants/colors.ts';
import {
    BODY_LG_LG_BOLD_STYLES,
    BODY_MD_MD_MEDIUM_STYLES,
    BODY_MD_MD_STYLES,
    BODY_SM_SM_BOLD_STYLES,
    BODY_SM_SM_MEDIUM_STYLES,
    BODY_SM_SM_STYLES,
    BODY_XS_XS_MEDIUM_STYLES,
    BODY_XS_XS_STYLES,
    HEADING_XS_STYLES,
} from '@constants/text.ts';
import styled, { css } from 'styled-components';

export const PathwaysWrapper = styled.div`
    display: flex;
    padding: var(--spacing-md, 24px);
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--colors-surface-primary, #fff);
    margin-bottom: var(--spacing-sm, 16px);
    flex: 1;

    .ant-input {
        color: var(--colors-text-filled, #2f3449);
        ${BODY_SM_SM_STYLES};
    }

    .ant-input::placeholder {
        color: var(--colors-text-on-disabled, #70768d);
    }
`;

export const Header = styled.div`
    color: var(--colors-text-headings, #3e445c);
    margin-bottom: var(--spacing-xs, 8px);
    ${HEADING_XS_STYLES};
`;

export const ChevronSectionIcon = styled(ChevronDownFilterIcon)<{ $expanded: boolean }>`
    transform: rotate(${({ $expanded }) => ($expanded ? '360deg' : '270deg')});
    width: 20px;
    height: 20px;
`;

const DEFAULT_CENTERED_CONTENT_STYLING = css`
    display: flex;
    justify-content: center;
    gap: 8px;
    align-items: center;
`;

export const MainButtonsWrapper = styled.div`
    ${DEFAULT_CENTERED_CONTENT_STYLING};
    justify-content: space-between;
    margin-bottom: var(--spacing-xs, 8px);
    span {
        ${BODY_SM_SM_MEDIUM_STYLES};
    }
    span.ant-btn-icon {
        margin-top: 4px;
    }
`;

export const MainButtonsIconWrapper = styled.div<{ $browserIcon: boolean }>`
    svg path[stroke] {
        stroke: ${({ $browserIcon }) =>
            $browserIcon ? 'var(--colors-surface-primary, #fff)' : 'var(--colors-text-action, #2171c6)'};
    }
    display: flex;
    gap: 8px;
`;

export const SectionActionsTableWrapper = styled.div`
    ${DEFAULT_CENTERED_CONTENT_STYLING};
`;

export const AddSubSectionAction = styled.button`
    ${DEFAULT_CENTERED_CONTENT_STYLING};
    gap: 6px;
    border: 0;
    padding: 0;
    background: transparent;
    color: var(--colors-text-action, #2171c6);
    cursor: pointer;
    white-space: nowrap;
    ${BODY_SM_SM_MEDIUM_STYLES};

    svg {
        width: 20px;
        height: 20px;
    }

    svg path[stroke] {
        stroke: currentColor;
    }
`;

export const SectionHeaderWrapper = styled.div`
    ${DEFAULT_CENTERED_CONTENT_STYLING};
    justify-content: flex-start;
`;

export const SectionHeaderTitle = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_LG_LG_BOLD_STYLES};
`;

export const SectionHeaderTitleExtraInfo = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_XS_XS_MEDIUM_STYLES};
`;

export const CheckboxLabel = styled.div<{ $bigTitle: boolean }>`
    color: var(--colors-text-body, #50566e);
    ${({ $bigTitle }) => ($bigTitle ? BODY_MD_MD_MEDIUM_STYLES : BODY_XS_XS_STYLES)};
`;

export const CheckboxLabelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const CheckboxWrapper = styled.div`
    ${DEFAULT_CENTERED_CONTENT_STYLING};
    justify-content: flex-end;
    margin-bottom: var(--spacing-xs, 8px);
`;

export const AddFinalQuizBannerWrapper = styled.div`
    display: flex;
    padding: var(--spacing-md, 24px);
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-xs, 8px);
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--neutral-100, #f9fafb);
    margin-top: var(--spacing-sm, 16px);
`;

export const AddFinalQuizWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: var(--spacing-md, 24px);
`;

export const AddFinalQuizTitle = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_BOLD_STYLES};
`;

export const AddFinalQuizLabel = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_XS_XS_STYLES};
`;

export const AddFinalQuizTotalTime = styled.div`
    color: var(--colors-text-action, #2171c6);
    ${BODY_XS_XS_MEDIUM_STYLES};
`;

export const SectionPlaceholderBoxTitle = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_MD_MD_STYLES};
`;

export const CertificatePreviewPageWrapper = styled.div`
    width: 100%;
    min-height: 100vh;

    .ant-alert {
        border: none;
        border-bottom: 1px solid ${BORDER_COLORS.warning};
        border-radius: 0;

        .ant-alert-title {
            font-weight: 700;
        }
    }
`;

export const CertificatePreviewFrame = styled.iframe`
    display: block;
    width: 100%;
    height: 297mm;
    border: none;
    overflow: hidden;
`;
